import React from 'react';

export const CoinsIcon = ({
  width = '20',
  height = '20',
  color = 'currentColor',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M7.85168 3.46502C10.2488 1.06675 14.1367 1.06768 16.5348 3.46502C18.9329 5.86236 18.9329 9.75051 16.5348 12.1488M13.9478 12.1923C13.9478 15.5839 11.1986 18.3333 7.80724 18.3333C4.41589 18.3333 1.66667 15.5839 1.66667 12.1923C1.66667 8.80069 4.41589 6.05126 7.80724 6.05126C11.1986 6.05126 13.9478 8.80069 13.9478 12.1923Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
